import styled from 'styled-components';

let w = 760;
let wfull = w * 2 + 100 + 'px';
w += 'px';

export const Content = styled.div`
  position: absolute;
  left: 145px;
  top: -14px;
  border-radius: 4px;
`;

export const WrapperVideo = styled.div`
  width: ${wfull};
  display: flex;
  justify-content: center;
  & img {
    max-height: none;
  }
  & > * {
    width: ${w};
    margin: 0 40px;
    overflow: hidden;
  }
`;
export const VideoLink = styled.a`
  display: block;
  width: 60px;
  height: 49px;
  transition: 0.15s all ease-out;
  border-radius: 5px;
  background: #5a5a5a url(/images/video.png) no-repeat 50%;
  background-size: 35px auto;
  margin: 0 0 100px;
  cursor: pointer;
  border: 1px solid #333;
  z-index: 99;
  position: relative;
  &:hover {
    background-color: #666;
  }
  &.active {
    border: 1px solid #999;
    background-color: #999;
  }
  &.active:hover {
    background-color: #aaa;
  }
`;
